<template>
<div class="shot_header">
  <el-date-picker
    class="date_picker"
    v-model="chooseDate"
    :picker-options="pickerOption"
    :editable="false"
    :clearable="false"
    size="small"
    value-format="yyyy-MM-dd">
  </el-date-picker>
  <MultiZoneSelector
    ref="zoneSel"
    class="area_select"
    placeholder="地区"
    searchPlaceHolder="请输入省/市/区"
    showTip
    showCheckbox
    size="small"
    :maxItemWidth="78"
    :leafLevel="4"
    :treeProps="treeProps"
    nodeKey="districtCode"
    :loadChildren="requestTreeData"
    :searchMethod="searchDistrict"
    @search="zoneSearch">
  </MultiZoneSelector>
  <el-input
    class="search_input"
    v-model="searchTxt"
    @keyup.enter="handleSearch"
    placeholder="查找小区"
    size="small"
    clearable>
    <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
  </el-input>
  <el-popover
    ref="namePop"
    width="224"
    placement="bottom"
    popper-class="adv_monit_pop"
    trigger="click"
    v-model="visible">
    <el-button slot="reference" class="submit_btn" size="small">
      <i class="iconfont icon-xiazaijietu"></i>
      <span>下载</span>
    </el-button>
    <div class="monit_task_form">
      <div class="task_props">
        <el-input
          class="name_area"
          type="textarea"
          placeholder="请输入任务名称"
          maxlength="30"
          :rows="3"
          show-word-limit
          resize="none"
          v-model="taskName"
          @blur="checkTaskName">
        </el-input>
        <div class="monit_types">
          <p class="title">监播图类型：</p>
          <el-checkbox-group v-model="mTypes">
            <el-checkbox label="camera">相机截图</el-checkbox>
            <el-checkbox label="screen">屏幕截图</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="down_mode">
          <p class="title">下载方式：</p>
          <el-radio-group v-model="mode">
            <el-radio :label="0">汇总</el-radio>
            <el-radio :label="1">分城市</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="bottom_btns">
        <div class="btn confirm" @click="confirmSubmit">确定</div>
        <div class="btn cancel" @click="cancelSubmit">取消</div>
      </div>
    </div>
  </el-popover>
  <slot></slot>
</div>
</template>

<script>
import { highlightKeyword } from '@/utils/functions'
import { districtTreeAsync, districtTreeSearch } from '@/utils/api'
import MultiZoneSelector from '@/components/MultiZoneSelector'

const AreaLevelMap = { 2: '省', 3: '市', 4: '区', 5: '街道' } // 地区各level所属级别map

export default {
  name: 'ShotHeader',
  components: { MultiZoneSelector },
  props: {
    date: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    pickerOption: { // 日期选择器控制选项
      type: Object,
      default () { return {} }
    }
  },
  data () {
    return {
      treeProps: {
        label: 'districtName',
        children: 'children',
        isLeaf: 'leaf',
        levelKey: 'districtLevel'
      },
      taskName: '',
      mTypes: ['camera','screen'], // 监播任务类型
      mode: 0, // 下载方式(默认"汇总")
      visible: false,
    }
  },
  computed: {
    chooseDate: {
      get () {
        return this.date
      },
      set (v) {
        this.$emit('update:date', v)
      }
    },
    searchTxt: {
      get () {
        return this.text
      },
      set (v) {
        this.$emit('update:text', v)
      }
    }
  },
  watch: {
    searchTxt (val, old) {
      val = val.replace(/\s*/g, '')
      this.$emit('update:text', val)
      this.handleSearch()
    }
  },
  beforeDestroy () {
    // 移除事件监听器
    this.$root.$off('screenMonitTaskSuccess')
    this.$root.$off('cameraMonitTaskSuccess')
  },
  mounted () {
    // 监听截图任务创建成功事件
    this.$root.$on('screenMonitTaskSuccess', () => {
      this.closePopover()
    })
    this.$root.$on('cameraMonitTaskSuccess', () => {
      this.closePopover()
    })
  },
  methods: {
    closePopover () { // 任务创建成功后隐藏名称输入弹窗并重置任务名
      if (this.$refs.namePop) this.$refs.namePop.doClose()
      this.taskName = ''
    },
    async requestTreeData (node) {
      let treePara = {}
      if (node.level === 0) {
        treePara = { districtLevel: 1, parentCode: 0 }
      } else if (node.data) {
        let { districtLevel, districtCode } = node.data
        treePara = { districtLevel, parentCode: districtCode }
      }
      let res = await districtTreeAsync(treePara)
      if (res.code === 0 && res.data) {
        let list = res.data || []
        list.forEach(child => {
          child.leaf = child.districtLevel === 4 // 到区级别
        })
        return list
      } else {
        return []
      }
    },
    async searchDistrict (keyword) { // 搜索异步区域树,只搜索到区级别
      let res = await districtTreeSearch({ keyWord: keyword, searchRange: 4 })
      if (res.code === 0 && res.data) {
        let list = res.data || []
        for (let i = 0; i < list.length; i++) {
          let el = list[i]
          let { districtLevel: curLevel, districtName } = el
          let belongs = ''
          if (curLevel > 1 && curLevel < 6) {
            belongs = AreaLevelMap[curLevel]
          } else {
            console.warn('区域level有误:', el)
          }
          el.belongs = belongs
          el.name = highlightKeyword(districtName, keyword)
        }
        return list
      }
      return []
    },
    zoneSearch (areas) {
      const zoneParam = (areas || []).map(({districtCode, districtLevel}) => { return { districtCode, levelNum: districtLevel } })
      this.$emit('filtrateNbhd', zoneParam)
    },
    handleSearch () {
      this.$emit('search')
    },
    checkTaskName (e) {
      let trimedStr = this.taskName.trim()
      this.taskName = trimedStr.replace(/[\\?\/:*"<>|]/ig, '')
    },
    confirmSubmit () {
      if (!this.taskName) return this.messageTip('请输入任务名称', 2)
      if (!this.mTypes.length) return this.messageTip('请至少选择一种类型')
      this.$emit('submit', this.taskName, this.mTypes, this.mode)
    },
    cancelSubmit () {
      this.taskName = ''
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.shot_header {
  margin-bottom: 10px;
  position: relative;
}
.date_picker {
  width: 120px;
  ::v-deep .el-input__inner {
    height: 30px;
    border-color: #e9e9e9;
    padding: 0 10px;
  }
  ::v-deep .el-input__prefix {
    left: auto;
    right: 5px;
  }
}
.area_select {
  background: #FFF;
  border: 1px solid #e9e9e9;
  border-radius:4px;
  width: 120px;
  height: 30px;
  line-height: 30px;
  margin-left: 10px;
  overflow: hidden;
  padding: 0 5px 0 10px;
}
.search_input {
  width: 200px;
  margin-left: 10px;
  ::v-deep .el-input__inner {
    border-color: #e9e9e9;
    border-radius: 4px;
    font-size: 12px;
    height: 30px;
  }
  ::v-deep .el-input-group__append {
    background: transparent;
    border: none;
    width: 30px;
    padding: 0;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    .el-button {
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
    }
  }
}
.submit_btn {
  float: right;
  border-color: #FF3973;
  border-radius: 4px;
  color: #FF3973;
  height: 30px;
  padding: 0px 22px;
  &:hover {
    background-color: #fff;
  }
  .iconfont {
    font-size: 16px;
    margin-right: 5px;
    vertical-align: text-bottom;
  }
}
</style>

<style lang="scss">
.adv_monit_pop {
  border-color: #E9E9E9;
  box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.13);
  color: #282729;
  padding: 0;
  .monit_task_form {
    height: 100%;
    padding-top: 20px;
    .task_props {
      height: calc(100% - 40px);
      border-radius: 4px;
      line-height: normal;
      padding: 0 12px 20px;
      .title {
        margin-bottom: 6px;
      }
      .name_area {
        border-radius: 4px;
        box-shadow: 0 0 0 1px #E9E9E9;
        .el-textarea__inner {
          border: none;
          color: #282729;
          padding: 10px;
        }
        .el-input__count {
          bottom: 10px;
        }
      }
      .monit_types {
        box-shadow: 0 1px 0 0 #E9E9E9;
        margin: 10px 0;
        padding-bottom: 10px;
        .el-checkbox {
          margin-right: 0;
          & + .el-checkbox {
            margin-left: 20px;
          }
          .el-checkbox__label {
            font-size: 12px;
            padding-left: 5px;
          }
        }
      }
      .el-radio {
        margin-right: 0;
        & + .el-radio {
          margin-left: 20px;
        }
        .el-radio__label {
          font-size: 12px;
          padding-left: 5px;
        }
        .el-radio__input.is-checked .el-radio__inner {
          background-color: #FF3973;
          border-color: #FF3973;
        }
      }
    }
    .bottom_btns {
      box-shadow: 0 -1px 0 0 #E9E9E9;
      height: 40px;
      line-height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      .btn {
        position: relative;
        cursor: pointer;
        width: 50%;
        height: 100%;
        text-align: center;
        &:not(:last-child) {
          &::after {
            content: '';
            background: #E9E9E9;
            width: 1px;
            position: absolute;
            right: 0;
            top: 10px;
            bottom: 10px;
          }
        }
        &.confirm {
          color: #FF3973;
        }
      }

    }
  }
}
</style>
